<div class="p-2">
    <adaa-data-table
        #adaaDataTable
        apiName="getMandatoryList"
        paramsString="itemType=66"
        [titleHeader]="'mandatory.title' | translate"
        [configKey]="constants.MAIN_TABLE_LIST_CONF_KEY.MANDATORYS"
        [itemTypeId]="constants.CONSTANT_PERMISSIONS.MANDATORY"
        [enableAdd]="false"
        [enableEditAction]="true"
        [enableDeleteAction]="true"
        [enableViewAction]="true"
        [enableAdd]="false"
        [enableViewAction]="false"
        [enableDeleteAction]="false"
        (actionClicked)="getAction($event)"
    ></adaa-data-table>
</div>
